import React, { Component } from 'react';
import { Container, Grid } from 'semantic-ui-react';

import Programming from './Programming';
import Languages from './Languages';
import Databases from './Databases';

export default class SkillsAndLanguages extends Component {
    render () {
        return (
            <Container>
                <Grid>
                    <Grid.Row columns={2}>
                        <Programming />
                    </Grid.Row>                    
                    <Grid.Row columns={2}>
                        <Databases />
                        <Languages />
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SkillsAndLanguages.js